import { useState } from "react";

import { ExistingDestination, Transfer } from "@prequel/react";
import { Button, ButtonStyle, ChevronRightIcon, Modal, Spinner } from "@prequel/shared-components";

import SyncSpecificModelsModal from "../SyncSpecificModelsModal";

type RetryTransferButtonProps = {
  destination: ExistingDestination;
  transfer: Transfer;
  isPostingTransfer: boolean;
};

const RetryTransferButton = ({ destination, transfer, isPostingTransfer }: RetryTransferButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        {showModal && (
          <SyncSpecificModelsModal
            destination={destination}
            fullRefresh={false}
            onCancel={() => setShowModal(false)}
            onConfirm={() => setShowModal(false)}
            initialSelectedModels={transfer.models}
            initialStartSyncTime={transfer.start_transfer_window_at}
            initialEndSyncTime={transfer.end_transfer_window_at}
            initialTags={transfer.tags}
          />
        )}
      </Modal>
      <Button
        text={
          isPostingTransfer ? (
            <div className="flex">
              <Spinner.Inline className="mr-3 text-emerald-600" /> Starting Sync
            </div>
          ) : (
            <div className="flex items-center">
              Re-run Transfer
              <ChevronRightIcon className="ml-1 size-4" />
            </div>
          )
        }
        type={ButtonStyle.TERTIARY}
        onClick={() => setShowModal(true)}
      />
    </>
  );
};

export default RetryTransferButton;
